module.exports = __webpack_public_path__ + "img/c01.ff4b1721.png";